<template lang="pug">
.insights-view(:class="{ ready, shown: insightsShown || roboShown, 'for-robo': roboShown, 'robo-done': roboShown && items && items.length, compact: insightsCloudShown }")
  //-.close(v-if="!focusMode", @click="insightsShown = roboShown = skimmerShown = null ")
  .close(@click="insightsShown = roboShown = skimmerShown = null ")
  global-events(@keyup.esc="insightsShown = false")
  .title Talking Points
    clipboard(v-if="items", :items="items.map(({ k, p }, i) => [`ic|${ insightsDoco }|${ p }|${ i }`, k, i])")
      .clear(v-if="clipboardItems && clipboardItems.length", @click="onClipboard = {}") &times;
  .document-info(v-if="!lens && document")
    .thumb(@click="toggleSkimmer",
           title="Toggle list",
           :style="{ 'background-image': `url('https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ insightsDoco }-1.png')` || '' }")
    .title {{ document && document.t }}
  //.instructions(v-if="roboShown") Analyze {{ genre }}
  .robo-form(v-if="roboShown")
    .instructions(v-if="roboShown") Analyze
    .text(v-if="roboShown")
      textarea(@keyup.enter="loadInsightsForText", placeholder="paste text here", v-model="roboText")
      //.cta(v-if="roboText && !roboFetching")
      .cta(:class="{ clickable }")
        button(@click="loadInsightsForText") Robo Analyze
  button-tab#insightsSentiment(v-if="lens", :style="focusMode && { opacity: 0, 'pointer-events': 'none' } || {}")
    template(slot="title") sentiment
    template(slot="content")
      .reset(@click="reset('InsightsSentiment')")
      .sentiment
        slider(v-model="insightsSentiment",
               :max="6",
               tooltip="none",
               :marks="true",
               :piecewiseLabel="true",
               v-bind="{ lazy: true, enableCross: false, piecewiseStyle: { backgroundColor: '#ccc', visibility: 'visible', width: '12px', height: '12px' }, piecewiseActiveStyle: { backgroundColor: '#8d6e4f' }, processStyle: { backgroundColor: '#8d6e4f' }, labelStyle: { color: 'transparent' } }")
  .insights-filter(:style="focusMode && { 'left': '0.5rem' } || {}")
    label
      .clearer(:class="{ hidden: !insightsFilter }", @click="insightsFilter = ''")
      input(placeholder="filter", v-model="insightsFilter")
  .toggle(:class="{ on: insightsCloudShown }", @click="insightsCloudShown = !insightsCloudShown")
    .charts
    .label {{ insightsCloudShown && 'hide' || 'show' }} word cloud
  .themes-toggle(v-if="insightsThemes", :class="{ on: insightsThemesShown || selectedInsightsThemes && Object.keys(selectedInsightsThemes).length || insightsCurrency || insightsNumeric }", @click="insightsThemesShown = !insightsThemesShown") Themes
  .insights-themes(v-if="insightsThemes", :class="{ shown: insightsShown && insightsThemesShown }")
    .selected-insights-themes
      .selected-insights-theme(v-for="(v, n) in selectedInsightsThemes",
                               @click="toggleSelectedInsightsTheme(n)",
                               :title="insightsThemes[n] && insightsThemes[n].t || ''") {{ insightsThemes[n] && insightsThemes[n].t || '' }}
      .currency-numeric
        .currency(@click="insightsCurrency = !insightsCurrency", :class="{ on: insightsCurrency }") currency
        .numeric(@click="insightsNumeric = !insightsNumeric", :class="{ on: insightsNumeric }") numeric
    .close(title="close themes", @click="insightsThemesShown = false") &times;
    .themes
      .theme(v-for="{ n, t, count, cth } in insightsThemes",
             :key="n", :title="`${ t }: ${ count }`",
             @click="toggleSelectedInsightsTheme(n)",
             :class="{ 'has-bar': count > 1, selected: selectedInsightsThemes[n], 'has-filter': !!cth }") {{ t }}
        .filter-toggle(v-if="!!cth", :title="insightsThemesParentFilter === n && 'show all' || `only show ${ t }`", :class="{ selected: insightsThemesParentFilter === n }", @click.stop="insightsThemesParentFilter = insightsThemesParentFilter !== n && n || ''")
        .bar(:style="{ width: `${ count * 3 }%` }", :title="t")
  .views
    .cloud(v-if="insightsCloudShown", keep-alive)
      vue-word-cloud(:words="wordCounts",
                      :animationDuration="0",
                      :color="color"
                      keep-alive
                      :rotation="rotation",
                      font-family="Roboto")
        template(slot-scope="{ word, text, weight }")
          .word(NOTstyle="cursor: pointer;", :title="weight", NOTATclick="tag(word)") {{ text }}
    .list(v-else)
      .items(v-if="items && itemsLength")
        .item(v-for="({ k, p, h }, index) in items",
              @click.self="toPDF(p)",
              :title="`Open page ${ [p, h] } in viewer`")
          //-:title="`Open page ${ p } in viewer`")
          .text(v-if="((h && h.split('|').length) || keywords) && ((h && h.split('|').length) || keywords && keywords.length) && insightsShown", @click.self="toPDF(p)")
            highlighter(:text-to-highlight="k",
                        :case-sensitive="true",
                        highlight-class-name="keyword",
                        highlight-tag="span",
                        @click="toPDF(p)",
                        :d-search-words="(h && h.split('|').length && h.split('|')) || keywords",
                        :search-words="(h && h.split('|').length && h.split('|')) || keywords")
          .text.no-highlight(v-else, @click.self="toPDF(p)") {{ k }}
          clipboard(:id="`ic|${ insightsDoco }|${ p }|${ index }`",
                    :text="k",
                    :url="`/?${ insightsDoco };pg=${ p }`",
                    :date="date((document || {}).dpa || new Date()) | moment('MMM Do, YYYY')",
                    :pub="(publishers[(document || {}).st] || {}).n || (document || {}).st",
                    :index="index")
      .no-results(v-else-if="!itemsLength && !roboShown && !roboFetching") No talking points for found for the relevant pages of this document
      .no-results(v-else-if="noResults") No talking points found
  .skimmer(:class="{ shown: skimmerShown }")
    .close(@click="toggleSkimmer")
    .items
      .item(v-for="(id, index) in readingList",
            :id="id",
            :class="{ selected: insightsDoco && id === insightsDoco || (!insightsDoco && !index) }",
            :style="{ 'background-image': `url('https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ id }-1.png` || '' }",
            @click.stop="openInsights(id)") &nbsp;
</template>
<!--template lang="pug">
.insights-view(:class="{ shown: insightsShown || roboShown, 'for-robo': roboShown, 'robo-done': roboShown && items && items.length}")
  .close(@click="insightsShown = roboShown = skimmerShown = null")
  .title(v-if="items") Talking points
    clipboard(:items="items.map(({ k, p }, i) => [`ic|${ insightsDoco }|${ p }|${ i }`, k, i])")
  .document-info(v-if="document")
    .thumb(@click="toggleSkimmer",
           title="Toggle list",
           :style="{ 'background-image': `url('https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ insightsDoco }-1.png')` || '' }")
    .title {{ document.t }}
  //.instructions(v-if="roboShown") Analyze {{ genre }}
  .instructions(v-if="roboShown") Analyze
  .text(v-if="roboShown")
    textarea(@keyup.enter="loadInsightsForText", placeholder="paste text here", v-model="roboText")
  .items(v-if="items")
    .item(v-for="({ k, p }, index) in items", :title="`On page ${ p }`")
      .text {{ k }}
      clipboard(:id="`ic|${ insightsDoco }|${ p }|${ index }`", :text="k", :index="index")
  .cta(v-else-if="roboText && !roboFetching")
    button(@click="loadInsightsForText") Robo Analyze
  .no-results(v-else-if="!items && !roboShown") No talking points for found for the relevant pages of this document
  .no-results(v-else-if="noResults") No talking points found
  .skimmer(:class="{ shown: skimmerShown }")
    .close(@click="toggleSkimmer")
    .items
      .item(v-for="(id, index) in readingList",
            :id="id",
            :class="{ selected: insightsDoco && id === insightsDoco || (!insightsDoco && !index) }",
            :style="{ 'background-image': `url('https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ id }-1.png')` || '' }",
            @click.stop="openInsights(id)") &nbsp;
</template-->
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
import highlighter from 'vue-highlight-words';
import vueSliderComponent from 'vue-slider-component';
import clipboard from '@/components/clipboard';
import buttonTab from '@/components/topo-components/button-tab';
export default {
  name: 'insights',
  data() {
    return { ready: false };
  },
  computed: {
    ...mapGetters([
      'insightsCache',
      'roboFetching',
      'genre',
      'insightsRoboCache',
      'submittedRoboText',
      'lens',
      'doco',
      'docoInsights',
      'selectedThemes',
      'selectedThemesWithAliases',
      'customThemes',
      'clipboardItems',
      'insightsThemes',
      'themes',
      'selectedInsightsThemes',
      'selectedInsightsThemesKeywords',
      'insightsWordCounts',
      'publishers',
      'focusMode'
    ]),
    //...vuexComputed('insightsDoco', 'insightsShown', 'roboText', 'roboShown', 'skimmerShown'),
    ...vuexComputed(
      'insightsShown',
      'roboText',
      'roboShown',
      'skimmerShown',
      'pdf',
      'insightsSentiment',
      'insightsFilter',
      'insightsCurrency',
      'insightsNumeric',
      'onClipboard',
      'insightsThemesShown',
      'insightsThemesParentFilter',
      'insightsCloudShown'
    ),
    //thms() {
    //  const { insightsThemes, themes } = this;
    //  return insightsThemes && Object.entries(insightsThemes).map(([n, count]) => ({ ...themes[n], count }));
    //},
    insightsDoco: {
      get() {
        return this.$store.getters.insightsDoco || this.doco;
      },
      set(value) {
        this.$store.dispatch('insightsDoco', value);
      }
    },
    // entry() {
    //   const { insightsCache, insightsDoco, roboShown, insightsRoboCache } = this;
    //   return roboShown ? insightsRoboCache?.fromText : insightsCache?.[insightsDoco];
    // },
    keywords() {
      const { selectedThemesWithAliases = [], insightsFilter, selectedInsightsThemes, selectedInsightsThemesKeywords } = this;
      //console.log('keywords', [...[...selectedThemesWithAliases, ...[].concat.apply([], Object.values(selectedInsightsThemesKeywords))].map(escapeRegExpAndBound), ...insightsFilter.split(/\s+/)].map(escapeRegExp));
      return [...[...selectedThemesWithAliases, ...[].concat.apply([], Object.values(selectedInsightsThemesKeywords))].map(escapeRegExpAndBound), ...insightsFilter.split(/\s+/).map(escapeRegExp)];
      function escapeRegExpAndBound(s) {
        return `\\b${ escapeRegExp(s) }\\b`; // $& means the whole matched string
      }
      function escapeRegExp(s) {
        return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`;
      }
    },
    entry() {
      return this.$store.getters.entry;
      //const { insightsDoco, insightsCache, selectedThemes, customThemes, docoInsights } = this;
      //let r = (insightsCache || {})[insightsDoco];
      //const length = Object.keys(selectedThemes).length;
      //console.log('filter kts', filter(), r?.kts);
      //return { ...r, kts: filter() };
      //function filter() {
      //  return (r?.kts || []).filter(
      //    ({ th, tg }) => !length || hasThemes(selectedThemes, th, customThemes, tg)
      //  );
      //}
      //function hasThemes(selectedThemes, th, customThemes, tg) {
      //  //Object.keys(selectedThemes);
      //  const cts = Object.keys(selectedThemes).filter(k => k / 1).map(k => customThemes[k]);
      //  return th?.some(t => selectedThemes[t]) || cts?.some(ct => hasKeywords(ct, tg));
      //  function hasKeywords({ selectedTags, andOr }, tg) {
      //    let r = true;
      //    const keys = Object.keys(selectedTags || {});
      //    //todo: aliases
      //    if (andOr === 'and') {
      //      keys.forEach(tag => {
      //        r = r && tg.includes(tag);
      //      });
      //    } else if (andOr === 'or') {
      //      if (keys.length) {
      //        r = tg.some(t => selectedTags[t]);
      //      }
      //    } else {
      //      keys.forEach(tag => {
      //        r = r && !tg.includes(tag);
      //      });
      //    }
      //    return r;
      //  }
      //  //return Object.keys(selectedThemes).some(({ n }) => th?.includes(n));
      //  //return th?.filter(t => selectedThemes[t]).length === Object.keys(selectedThemes).length;
      //}
      //return this.docoInsights;
    },
    document() {
      return this.entry?.ds;
    },
    items() {
      const { entry, insightsSentiment, insightsFilter, selectedInsightsThemes, insightsCurrency, insightsNumeric } = this;
      const [min, max] = insightsSentiment;
      return entry?.kts
        ?.filter(({ sq }) => min <= sq && sq <= max)
        .filter(({ k, th = [] }) => {
          return insightsFilter.split(/\s+/).every(testWord);
          function testWord(word) {
            const tester = new RegExp(escapeRegExp(word), 'i');
            return tester.test(`${ k || '' }|${ th?.join('|') || '' }`);
          }
          function escapeRegExp(s) {
            return `${ s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }`; // $& means the whole matched string
          }
        })
        .filter(item => hasCurrencyOrNumeric(item) && hasThemes(item));
      function hasCurrencyOrNumeric({ hm, hn }) {
        let r = true;
        if (insightsCurrency && insightsNumeric) {
          return hm || hn;
        } else if (insightsCurrency) {
          r = hm;
        } else if (insightsNumeric) {
          r = hn;
        }
        return r;
      }
      function hasThemes({ k, th = [] }) {
        const selected = Object.keys(selectedInsightsThemes);
        const themes = [k, ...(th?.pop && th || [])];
        // todo: expand s to include all aliases aka th
        return !selected.length || selected.some(s => themes.includes(s));
      }
    },
    itemsLength() {
      return this.entry?.kts?.length;
    },
    readingList() {
      return this.$store.getters['documentsNS/readingList'];
    },
    clickable() {
      const { roboText, submittedRoboText } = this;
      return roboText && roboText !== submittedRoboText;
    },
    noResults() {
      const { roboShown, clickable, submittedRoboText, items } = this;
      return roboShown && !clickable && !items && submittedRoboText;
    },
    medianValue() {
      return this.wordCounts?.medianValue;
    },
    wordCounts() {
      //console.log('insightsWordCounts', docoInsights || 'no di');
      // todo: move this into insights.vue and use items as the base
      const { items } = this;
      //console.log('word counts items', items);
      const r =
        (items &&
          Object.entries(
            items.reduce((all, kt) => {
              Object.entries(tallyWords(kt)).forEach(([k, count]) => {
                all[k] = all[k] || 0;
                all[k] += count;
              });
              return all;
            }, {})
          )
            .sort((a, b) => b[1] - a[1])
            .filter((_, i) => i < 50)) ||
        [];
      const counts = r.map(([_, c]) => c);
      r.maxValue = Math.max.apply(null, counts);
      r.minValue = Math.min.apply(null, counts);
      r.medianValue = counts.reduce((total, c) => total + c) / counts.length;
      return r;
      function tallyWords({ h }) {
        return (
          h?.split(/\|/).reduce((all, word) => {
            all[word] = all[word] || 0;
            all[word]++;
            return all;
          }, {}) || {}
        );
      }
    }
  },
  methods: {
    ...mapActions(['loadInsightsForText', 'toggleSelectedInsightsTheme']),
    analyze() {
      if (this.clickable) {
        this.loadInsightsForText();
      }
    },
    date(d) {
      return new Date(d);
    },
    async openInsights(id) {
      //const { currentDocument: { did: id }, pages } = this;
      //todo: handle skimmer
      return;
      this.insightsDoco = id;
      await this.$store.dispatch('loadInsights', { id });
      this.insightsShown = true;
    },
    toggleSkimmer() {
      this.skimmerShown = !this.skimmerShown;
    },
    toPDF(p) {
      console.log('toPDF', p, this.pdf);
      this.pdf = this.pdf.replace(/(?:\-\d+)?.pdf/, `-${ p }.pdf`);
      window.scrollBy({ behavior: 'smooth', top: document.querySelector('.analysis .viewer').getBoundingClientRect().top - 50 });
    },
    hasFilter(n) {
      return !!this.themes?.[n]?.cth;
    },
    reset(type) {
      this.$store.dispatch('reset' + type);
    },
    rotation([, weight]) {
      const { medianValue } = this;
      // return (weight < medianValue && 0.75) || 0;
      return 0;
    },
    color([, weight]) {
      const { medianValue } = this;
      return (weight > medianValue && 'orange') || (weight > 10 && '#8d6e4f') || '#282828';
    }
  },
  components: {
    slider: vueSliderComponent,
    highlighter,
    clipboard,
    buttonTab,
    VueWordCloud: () => import('vuewordcloud')
  },
  mounted() {
    // this.insightsShown = false;
    // setTimeout(() => this.ready = true, 400);
  }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.insights-view {
  position: fixed;
  top: 4.3rem;
  left: 0;
  bottom: 0;
  width: 20vw;
  z-index: 6999;
  background-color: white;
  display: grid;
  //grid-template-rows: 2rem 3.5rem 1fr;
  //grid-template-rows: 2rem 1fr;
  //grid-template-rows: 2rem 2.8rem 1fr;
  grid-template-rows: 2rem 2.8rem 1fr;
  padding: 0.125rem;
  transform: translate3d(-150vw, 0, 0);
  transition: transform 250ms ease-in-out;
  will-change: transform;
  box-shadow: 1px 2px 3px #ccc;
  //opacity: 0;
  &:not(.compact) {
    bottom: 0;
  }
  &.compact {
    //height: 20rem;
    //height: 40rem;
    bottom: 0;
  }
  &.ready {
    //opacity: 1;
  }
  & > .title {
    overflow: visible;
    text-align: left;
    & > .copy {
      position: absolute;
      top: -1.52rem;
      right: 3.5rem;
      z-index: 1;
      &:hover {
        .paper {
          opacity: 1;
        }
      }
      .clear {
        position: absolute;
        top: 1rem;
        right: -1.15rem;
        width: 0.5rem;
        height: 0.5rem;
        font-size: 0.9rem;
        padding: 0.25rem;
        //background-color: lawngreen;
        cursor: pointer;
        &:hover {
          color: black;
          opacity: 1;
        }
      }
    }
  }
  .insights-filter {
    position: absolute;
    left: 8rem;
    top: 2.25rem;
    label {
      position: relative;
      input {
        border: 1px solid #efefef;
        line-height: 1.4rem;
        width: 7rem;
        color: $brn;
        transition: border-color 250ms ease-in-out;
        &:focus {
          border-color: #9a9a9a;
          outline: none;
        }
      }
    }
  }
  & > .toggle {
    //border: 3px solid #eee;
    border: 3px solid transparent;
    border-radius: 50%;
    height: 2rem;
    width: 2rem;
    position: absolute;
    top: 0;
    right: 5rem;
    cursor: pointer;
    transition: border-color 250ms ease-in-out;
    will-change: border-color;
    transform: scale(0.75);
    transform-origin: center;
    &:hover {
      border-color: #eee;
    }
    &.on {
      border-color: orange !important;
    }
    &.hide {
      visibility: hidden;
      pointer-events: none;
    }
    .label {
      pointer-events: none;
      position: absolute;
      top: 2.25rem;
      left: 50%;
      transform: translate3d(-50%, 0, 0);
      font-size: 0.8rem;
      font-weight: 500;
      color: white;
      background-color: $brn;
      border-radius: 0.25rem;
      padding: 0.25rem 0.5rem;
      //border: 1px solid #efefef;
      opacity: 0;
      white-space: nowrap;
      transition: opacity 250ms ease-in-out;
      will-change: opacity;
    }
    &:hover {
      .label {
        opacity: 1 !important;
      }
    }
    & > .charts {
      position: relative;
      top: 0.25rem;
      left: 0.3rem;
      width: 1.5rem;
      height: 1.5rem;
      border-radius: 0.25rem;
      background: white center no-repeat
      url("data:image/svg+xml;charset%3Dutf8,%3Csvg xmlns%3D'http://www.w3.org/2000/svg' width%3D'48' height%3D'48' viewBox%3D'0 0 48 48'%3E%3Cpath fill%3D'%238d6e4f' d%3D'M38 6h-28c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4zm-20 28h-4v-14h4v14zm8 0h-4v-20h4v20zm8 0h-4v-8h4v8z'/%3E%3Cpath d%3D'M0 0h48v48h-48z' fill%3D'none'/%3E%3C/svg%3E");
      background-size: contain;
    }
  }
  .skimmer {
    //todo: handle skimmer
    display: none;
    position: fixed;
    top: 1rem;
    bottom: 1rem;
    left: 21vw;
    width: 76vw;
    background-color: white;
    box-shadow: 1px 1px 3px black;
    border-radius: 0.25rem;
    transform: translate3d(-110vw, 0, 0);
    transform-origin: top left;
    transition: transform 500ms ease-in-out;
    will-change: transform;
    padding: 0 !important;
    z-index: -1;
    cursor: pointer;

    &.shown {
      transform: none;
    }
    //&.open {
    cursor: default;
    //transform: none;
    padding: 1rem !important;
    .items {
      pointer-events: all;
      /*grid-template-columns: repeat(5, 20%);*/
      grid-template-columns: repeat(7, 1fr);
      overflow: auto;
      max-height: 85vh;
      .item {
        display: block;
        //width: 6rem;
        margin: 0.25rem;
        &.selected {
          pointer-events: all;
          box-shadow: 1px 1px 5px black;
        }
        &.heading {
          grid-column-start: 1;
          grid-column-end: 6;
          width: 100%;
          box-sizing: border-box;
          border: 1px solid #efefef;
          border-bottom-color: $brn;
          border-bottom-width: 2px;
          outline: none;
          padding-top: 0;
          margin: 1.5rem 0 0.25rem;
          font-weight: 500;
          //color: white;
          color: $brn;
          font-size: 2rem;
          /*text-shadow: 0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn,
                       0 0 1px $brn;*/
          -webkit-font-smoothing: antialiased;
          input {
            width: 100%;
            // height: 2rem;
            font-weight: 250;
            font-size: 2rem;
            text-align: center;
            color: $brn;
            outline: none;
            border: none;
          }
        }
      }
    }
    .close {
      pointer-events: all;
      display: block;
    }
    .count {
      display: none;
    }
    //}
    .count {
      position: absolute;
      top: 0;
      left: 100%;
      transform: translate3d(0.5rem, 0, 0);
    }
    .close {
      display: none;
      position: absolute;
      top: 0.25rem;
      right: 0.25rem;
      height: 3rem;
      width: 3rem;
      &:hover {
        &::after {
          color: black;
        }
      }
      &::after {
        color: #dadada;
        cursor: pointer;
        content: '\00d7';
        position: absolute;
        top: -0.3rem;
        right: -0rem;
        font-size: 1.25rem;
        //margin-top: -0.05rem;
        //transform: translate3d(0, -70%, 0);
      }
    }
    .items {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      //grid-template-columns: 100%;
      .item {
        //display: none;
        //width: 3rem;
        padding-top: 100%;
        background: white no-repeat center;
        background-size: contain;
        outline: 2px solid #dadada;
        position: relative;
        //box-shadow: 1px 1px 3px black;
        cursor: pointer;
        //outline: 1px solid black;
        transition: transform 250ms ease-in-out;
        will-change: transform;
        //&.drop-target {
        //  transform: translate3d(1.5rem, 0, 0);
        //  &::before {
        //    content: '\00a0';
        //    position: absolute;
        //    top: 0;
        //    left: -1rem;
        //    height: 100%;
        //    width: 0.25rem;
        //    background-color: $brn;
        //  }
        //}
        &.selected {
          pointer-events: none;
          display: block;
          outline: 2px solid orange;
          /*box-shadow: 1px 1px 3px black,
                      1px 1px 6px black,
                      1px 1px 9px black;*/
        }
      }
    }
  }
  &.for-robo {
    grid-template-rows: 2rem 11.5rem 1fr;
    &.robo-done {
      //grid-template-rows: 2rem 2.5rem 1fr 1fr;
    }
    .skimmer {
      display: none;
    }
    .robo-form {
      position: relative;
      & > .text {
        position: relative;
        height: 9.25rem;
        //padding-bottom: 1rem;
        textarea {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 1.5rem;
          right: 0;
          width: 99%;
          /*height: 100%;*/
          border: 1px solid #efefef;
          &:focus {
            outline: none;
          }
        }
        .cta {
          position: absolute;
          bottom: -0.25rem;
          left: 0;
          right: 0.5rem;
          display: flex;
          justify-content: flex-end;
          opacity: 0.5;
          will-change: opacity;
          transition: opacity 300ms ease-in-out;
          &.clickable {
            opacity: 1;
          }
          button {
            //height: 1.5rem;
            font-size: 0.9rem;
            font-weight: 500;
            padding: 0.125rem 0.5rem;
            border: 1px solid white;
            border-radius: 0.25rem;
            background-color: $brn;
            color: white;
            cursor: pointer;
            &:focus {
              outline: none;
            }
          }
        }
      }
      .instructions {
        padding: 0.25rem 1rem 0.25rem 0.25rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  &.shown {
    transform: none;
  }
  & > .close {
    position: absolute;
    top: 0.25rem;
    right: 0.25rem;
    height: 2rem;
    width: 2rem;
    z-index: 1;
    &:hover {
      &::after {
        color: black;
      }
    }
    &::after {
      color: #dadada;
      cursor: pointer;
      content: '\00d7';
      position: absolute;
      top: -0.5rem;
      right: 0.3rem;
      font-size: 2rem;
      //margin-top: -0.05rem;
      //transform: translate3d(0, -70%, 0);
    }
  }
  & > .title {
    padding: 0.125rem;
    text-align: left;
    font-size: 1.5rem;
    color: $brn;
    position: relative;
    overflow: hidden;
    & >>> .copy {
      position: absolute;
      //top: -1.4rem;
      //left: 50%;
      margin-left: 2.5rem;
    }
  }
  .document-info {
    position: relative;
    padding: 0.5rem 0.5rem 0.5rem 3rem;
    .title {
      font-size: 0.9rem;
    }
    .thumb {
      cursor: pointer;
      width: 2rem;
      height: 2.75rem;
      background: no-repeat center;
      background-size: contain;
      box-shadow: 1px 1px 2px #ccc;
      position: absolute;
      top: 0.125rem;
      left: 0.125rem;
    }
  }
  .themes-toggle {
    cursor: pointer;
    position: absolute;
    top: 2.5rem;
    right: 0.5rem;
    text-transform: uppercase;
    font-size: 0.95rem;
    border-bottom: 2px solid transparent;
    color: #9a9a9a;
    &.on {
      color: black;
      border-bottom-color: orange;
    }
  }
  .insights-themes {
    position: absolute;
    top: 0;
    left: 100%;
    margin-left: 0.125rem;
    padding: 2.25rem 1rem 1rem;
    //margin-left: 1rem;
    background-color: white;
    border: 1px solid $brn;
    border-top-width: 0;
    border-left-width: 0;
    box-sizing: border-box;
    width: 75vw;
    //max-height: calc(100vh - 6rem);
    z-index: -1;
    transform: translate3d(-150vw, 0, 0);
    //opacity: 0;
    transition: transform 250ms ease-in-out;
    will-change: transform;
    &.shown {
      transform: translate3d(0, 0, 0);
      //opacity: 1;
    }
    .close {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      cursor: pointer;
    }
    .selected-insights-themes {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding-left: 0.25rem;
      padding-right: 12.5rem;
      min-height: 2rem;
      position: relative;
      & * {
        user-select: none;
      }
      .currency-numeric {
        display: flex;
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translate3d(0, -50%, 0);
        .currency,
        .numeric {
          cursor: pointer;
          user-select: none;
          box-sizing: border-box;
          width: 5rem;
          text-align: center;
          padding: 0.125rem 0.5rem;
          border: 1px solid #dadada;
          border-radius: 0.125rem;
          margin-left: 0.5rem;
          font-size: 0.7rem;
          text-transform: uppercase;
          cursor: pointer;
          color: $brn;
          background-color: white;
          transition: all 250ms ease-in-out;
          &.on {
            font-weight: 600;
            color: white;
            background-color: $brn;
            border-color: $brn;
          }
        }
      }
      .selected-insights-theme {
        cursor: pointer;
        font-size: 0.8rem;
        flex: none;
        margin: 0.25rem;
        padding: 0.25rem 0.5rem;
        padding-right: 1rem;
        border-radius: 0.125rem;
        background: $brn;
        color: white;
        position: relative;
        max-width: 6rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        &:hover {
          &::after {
            content: '\00d7';
            position: absolute;
            top: 0.25rem;
            right: 0.25rem;
          }
        }
      }
    }
    .themes {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 0.25rem;
      overflow: auto;
      max-height: calc(100vh - 12rem);
      cursor: pointer;
      padding: 0.25rem 0.75rem;

      .theme {
        text-align: left;
        font-size: 0.85rem;
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        $bar-height: 0.25rem;
        padding: 1.5 * $bar-height 0.25rem 1.5 * $bar-height;
        border: 1px solid transparent;
        transition: transform 250ms ease-in-out;
        background-color: white;
        transform: rotate(0);
        //will-change: border-color;
        &:hover {
          border-color: $brn;
          transform: scale(1.05);
          z-index: 1;
        }
        &.selected {
          border-color: $brn;
        }
        &.has-bar {
          padding-left: 0.25rem;
          &.has-filter {
            padding-left: 1rem;
          }
          &:after {
            content: '';
            position: absolute;
            left: 0.25rem;
            right: 0.25rem;
            bottom: 0;
            height: $bar-height;
            background-color: rgba($brn, 0.0625);
            border-radius: $bar-height / 2;
            z-index: -1;
            pointer-events: none;
          }
          .bar {
            display: block;
            position: absolute;
            left: 0.25rem;
            bottom: 0;
            height: $bar-height;
            max-width: 90%;
            //background-color: rgba($brn, 0.125);
            background-color: orange;
            //border-top: $bar-height solid transparent;
            //border-bottom: $bar-height solid orange;
            border-top-left-radius: $bar-height / 2;
            border-bottom-left-radius: $bar-height / 2;
            //overflow: hidden;
            pointer-events: none;
            //z-index: -1;
            //&:after {
            //  //content: attr(title);
            //  position: absolute;
            //  top: 0;
            //  left: 0.25rem;
            //  color: white;
            //}
          }
          .filter-toggle {
            position: absolute;
            top: 0.3rem;
            left: 0;
            width: 1.2rem;
            height: 1.2rem;
            background: no-repeat center
            url("data:image/svg+xml;charset%3Dutf8,%3C?xml version%3D'1.0' encoding%3D'UTF-8'?%3E%3Csvg xmlns%3D'http://www.w3.org/2000/svg' viewBox%3D'-2 -256 1792 1792'%3E%3Cg transform%3D'matrix(1,0,0,-1,182.23729,1201.8983)'%3E%3Cpath style%3D'fill:%238d6e4f;' d%3D'm 1403,1241 q 17,-41 -14,-70 L 896,678 V -64 q 0,-42 -39,-59 -13,-5 -25,-5 -27,0 -45,19 L 531,147 q -19,19 -19,45 V 678 L 19,1171 q -31,29 -14,70 17,39 59,39 h 1280 q 42,0 59,-39 z'/%3E  %3C/g%3E%3C/svg%3E");
            background-size: 75%;
            opacity: 0.5;
            transition: opacity 250ms ease-in-out;
            will-change: opacity;
            &:hover,
            &.selected {
              opacity: 1;
            }
          }
        }
        .bar {
          display: none;
        }
      }
    }
  }
  .views {
    //height: 100%;
    overflow: auto;
    .cloud {
      height: 100%;
      //background-color: $brn;
    }
    .list {
      //height: 100%;
    }
  }

  .items {
    //height: 100%;
    //overflow: auto;
    /*display: grid;*/
    /*row-gap: 0.25rem;*/
    border-top: 1px solid orange;
    background-color: white;
    padding-top: 0.25rem;
    .item {
      padding: 0.5rem 0.8rem 0.5rem 0.125rem;
      border-bottom: 1px solid #e1e1e1;
      position: relative;
      text-align: left;
      cursor: pointer;
      & >>> .copy {
        position: absolute;
        bottom: 0.5rem;
        right: 0.5rem;
        .paper {
          opacity: 0;
        }
      }
      &:hover >>> .copy .paper {
        opacity: 0.35;
      }
    }
  }
  .no-results {
    padding: 0.5rem;
    font-size: 1.2rem;
    padding-bottom: 50vh;
  }
}
</style>
<style lang="scss">
@import '../../scss/global';
.insights-view {
  &.shown {
    .button-tab {
      .sentiment {
        .vue-slider {
          transform: none;
          opacity: 1;
          pointer-events: all;
        }
      }
    }
  }
  .button-tab {
    .toggler {
      width: 7rem;
      position: relative;
    }
    .sentiment {
      .vue-slider {
        transform: translate3d(30vw, 0, 0);
        opacity: 0;
        pointer-events: none;
      }
    }
  }
  .items {
    position: relative;
    .item {
      .text {
        .keyword {
          color: $brn;
        }
      }
      .copy {
        position: absolute;
        bottom: 0.5rem;
        right: 0.5rem;
        .paper {
          opacity: 0;
        }
      }
      &:hover .copy .paper {
        opacity: 0.35;
      }
    }
  }
}
</style>
